import type { GlobalApiPaymentDetails } from '@data/global-api-payments';
import { CURRENT_SERVICE_TYPE } from '@utility/checkout-utils';

import { getScaHeaders, SCA_API_ENDPOINTS } from '../../global.constants';
import { useScaMutation } from '../useScaMutation';

import type {
  PatchPaymentDetailsBody,
  UseUpdatePaymentDetailsParams,
} from './useUpdatePaymentDetails.types';

export const useUpdatePaymentDetails = ({
  paymentId,
  authToken,
}: UseUpdatePaymentDetailsParams) => {
  return useScaMutation<GlobalApiPaymentDetails, PatchPaymentDetailsBody>({
    url: SCA_API_ENDPOINTS.patchPaymentDetails(paymentId, CURRENT_SERVICE_TYPE),
    method: 'PATCH',
    headers: getScaHeaders({ authToken }),
  });
};
